var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCornerArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59998 3.99998C3.59998 3.77906 3.77906 3.59998 3.99998 3.59998H7.99998C8.63649 3.59998 9.24694 3.85283 9.69703 4.30292C10.1471 4.75301 10.4 5.36346 10.4 5.99998V11.701L12.3838 9.71713C12.54 9.56092 12.7933 9.56092 12.9495 9.71713C13.1057 9.87334 13.1057 10.1266 12.9495 10.2828L10.2828 12.9495C10.1266 13.1057 9.87334 13.1057 9.71713 12.9495L7.05047 10.2828C6.89426 10.1266 6.89426 9.87334 7.05047 9.71713C7.20668 9.56092 7.45994 9.56092 7.61615 9.71713L9.59998 11.701V5.99998C9.59998 5.57563 9.4314 5.16866 9.13135 4.8686C8.83129 4.56855 8.42432 4.39998 7.99998 4.39998H3.99998C3.77906 4.39998 3.59998 4.22089 3.59998 3.99998Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerArrowDown);
export default __webpack_public_path__ + "static/media/corner_arrow_down.b229d40fd8fa9f5539fd5f0f7104434f.svg";
export { ForwardRef as ReactComponent };